import React from "react";
import checkAndConnector from "../../../assets/Connector wrap.svg";
import greenCheck from "../../../assets/green-check-with-circle.svg";
import { useTranslation } from "react-i18next";

const ModalBody = () => {

  const {t} = useTranslation();

  const data = [
    t('add_edit_product_27'),
    t('add_edit_product_28'),
    t('add_edit_product_29'),
  ];

  return (
    <div className="flex flex-col gap-3">
      <div>
        <p className="text-2xl font-medium">{t('add_edit_product_24')}</p>
        <p className="text-sm text-grey-75">
        {t('add_edit_product_25')}
        </p>
      </div>
      <div>
        <p className="font-medium">{t('add_edit_product_26')}</p>
        <div className="flex flex-col gap-2 ">
          {data.map((item, index) => (
            <div key={index} className="flex gap-2 items-start">
              {index !== data.length - 1 ? (
                <img src={checkAndConnector} alt="connector" />
              ) : (
                <img src={greenCheck} alt="connector" />
              )}
              <p className="text-sm text-grey-75">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalBody;
